import script from "./WorkflowNodeSettings.vue?vue&type=script&lang=js"
export * from "./WorkflowNodeSettings.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__